var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpanish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.2475C0 17.4056 0.93882 18.3445 2.09699 18.3445H25.903C27.0611 18.3445 28 17.4057 28 16.2475V14.4824H0V16.2475Z",
    fill: "#C8414B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.903 0H2.09699C0.93882 0 0 0.93882 0 2.09699V3.86209H28V2.09699C28 0.93882 27.0612 0 25.903 0Z",
    fill: "#C8414B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 3.8623H0V14.4832H28V3.8623Z",
    fill: "#FFD250"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8275 9.17246L12.2368 7.33053C12.2746 7.16089 12.1455 7 11.9717 7H11.6834C11.5096 7 11.3806 7.16095 11.4182 7.33053L11.8275 9.17246Z",
    fill: "#C8414B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3102 8.20703H11.3447V12.3102H12.3102V8.20703Z",
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5518 7.72461H11.1035V8.20739H12.5518V7.72461Z",
    fill: "#FAB446"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5516 9.17188H10.1377V9.65466H12.5516V9.17188Z",
    fill: "#C8414B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5518 11.1032L11.1035 10.6205V10.1377L12.5518 10.6205V11.1032Z",
    fill: "#C8414B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5863 9.17246L4.99564 7.33053C5.03337 7.16089 4.90426 7 4.73046 7H4.44215C4.2684 7 4.13934 7.16095 4.17697 7.33053L4.5863 9.17246Z",
    fill: "#C8414B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27575 7.72461C6.00915 7.72461 5.79297 7.94079 5.79297 8.20739V11.3453C5.79297 11.9318 6.34039 13.035 8.20677 13.035C10.0731 13.035 10.6206 11.9319 10.6206 11.3453V8.20739C10.6206 7.94079 10.4044 7.72461 10.1378 7.72461H6.27575Z",
    fill: "#F5F5F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20677 10.1384H5.79297V8.20739C5.79297 7.94079 6.00915 7.72461 6.27575 7.72461H8.20677V10.1384Z",
    fill: "#C8414B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20654 10.1377H10.6203V11.3446C10.6203 12.0112 10.08 12.5515 9.41344 12.5515C8.74686 12.5515 8.20654 12.0112 8.20654 11.3446V10.1377Z",
    fill: "#C8414B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79297 10.1387H8.20677V11.3456C8.20677 12.0122 7.66645 12.5525 6.99987 12.5525C6.33328 12.5525 5.79297 12.0122 5.79297 11.3456V10.1387Z",
    fill: "#FAB446"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72448 12.3057V10.1387H7.2417V12.5281C7.42129 12.4917 7.58355 12.4122 7.72448 12.3057Z",
    fill: "#C8414B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75866 12.5281V10.1387H6.27588V12.3057C6.41686 12.4122 6.57912 12.4917 6.75866 12.5281Z",
    fill: "#C8414B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72417 9.17188H6.27588V9.65466H7.72417V9.17188Z",
    fill: "#FFB441"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72417 8.20703H6.27588V8.68981H7.72417V8.20703Z",
    fill: "#FAB446"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4826 8.49414H6.51709V9.3687H7.4826V8.49414Z",
    fill: "#FAB446"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06902 8.20703H4.10352V12.3102H5.06902V8.20703Z",
    fill: "#F5F5F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31011 12.0693H3.86182V12.5521H5.31011V12.0693Z",
    fill: "#FAB446"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31011 7.72461H3.86182V8.20739H5.31011V7.72461Z",
    fill: "#FAB446"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55211 12.5518H3.62109V13.0345H5.55211V12.5518Z",
    fill: "#5064AA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.793 12.0693H11.3447V12.5521H12.793V12.0693Z",
    fill: "#FAB446"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7928 12.5518H10.8618V13.0345H12.7928V12.5518Z",
    fill: "#5064AA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65537 7.24121H6.75879V7.72399H9.65537V7.24121Z",
    fill: "#FAB446"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4486 5.79297H7.96582V7.24126H8.4486V5.79297Z",
    fill: "#FFB441"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72412 6.51757C7.32479 6.51757 7 6.19273 7 5.79345C7 5.39412 7.32484 5.06934 7.72412 5.06934C8.12345 5.06934 8.44823 5.39418 8.44823 5.79345C8.44829 6.19273 8.12345 6.51757 7.72412 6.51757ZM7.72412 5.55206C7.59095 5.55206 7.48273 5.66023 7.48273 5.79345C7.48273 5.92662 7.5909 6.03484 7.72412 6.03484C7.85734 6.03484 7.96551 5.92667 7.96551 5.79345C7.96551 5.66029 7.85734 5.55206 7.72412 5.55206Z",
    fill: "#F5F5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68945 6.51757C8.29012 6.51757 7.96533 6.19273 7.96533 5.79345C7.96533 5.39412 8.29018 5.06934 8.68945 5.06934C9.08878 5.06934 9.41357 5.39418 9.41357 5.79345C9.41357 6.19273 9.08872 6.51757 8.68945 6.51757ZM8.68945 5.55206C8.55628 5.55206 8.44806 5.66023 8.44806 5.79345C8.44806 5.92662 8.55623 6.03484 8.68945 6.03484C8.82261 6.03484 8.93084 5.92667 8.93084 5.79345C8.93078 5.66029 8.82261 5.55206 8.68945 5.55206Z",
    fill: "#F5F5F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65478 6.99999C9.25545 6.99999 8.93066 6.67515 8.93066 6.27587C8.93066 5.87655 9.25551 5.55176 9.65478 5.55176C10.0541 5.55176 10.3789 5.8766 10.3789 6.27587C10.3789 6.67515 10.0541 6.99999 9.65478 6.99999ZM9.65478 6.03448C9.52162 6.03448 9.41339 6.14266 9.41339 6.27587C9.41339 6.40904 9.52156 6.51727 9.65478 6.51727C9.78795 6.51727 9.89617 6.40909 9.89617 6.27587C9.89617 6.14266 9.78795 6.03448 9.65478 6.03448Z",
    fill: "#F5F5F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7583 6.99999C6.35897 6.99999 6.03418 6.67515 6.03418 6.27587C6.03418 5.87655 6.35902 5.55176 6.7583 5.55176C7.15762 5.55176 7.48241 5.8766 7.48241 6.27587C7.48247 6.67515 7.15762 6.99999 6.7583 6.99999ZM6.7583 6.03448C6.62513 6.03448 6.51691 6.14266 6.51691 6.27587C6.51691 6.40904 6.62508 6.51727 6.7583 6.51727C6.89152 6.51727 6.99969 6.40904 6.99969 6.27582C6.99969 6.14266 6.89152 6.03448 6.7583 6.03448Z",
    fill: "#F5F5F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65502 11.1038V11.3452C9.65502 11.4783 9.54673 11.5866 9.41363 11.5866C9.28052 11.5866 9.17223 11.4783 9.17223 11.3452V11.1038H9.65502ZM10.1377 10.6211H8.68945V11.3452C8.68945 11.7445 9.0143 12.0693 9.41357 12.0693C9.8129 12.0693 10.1377 11.7445 10.1377 11.3452V10.6211H10.1377Z",
    fill: "#FAB446"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41393 9.65538C9.14733 9.65538 8.93115 9.4392 8.93115 9.17259V8.68981C8.93115 8.42321 9.14733 8.20703 9.41393 8.20703C9.68054 8.20703 9.89672 8.42321 9.89672 8.68981V9.17259C9.89672 9.4392 9.68054 9.65538 9.41393 9.65538Z",
    fill: "#FFA0D2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20703 10.8623C8.60695 10.8623 8.93114 10.5381 8.93114 10.1382C8.93114 9.73826 8.60695 9.41406 8.20703 9.41406C7.80711 9.41406 7.48291 9.73826 7.48291 10.1382C7.48291 10.5381 7.80711 10.8623 8.20703 10.8623Z",
    fill: "#5064AA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4486 4.82812H7.96582V6.27641H8.4486V4.82812Z",
    fill: "#FAB446"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75866 7.24126L6.27588 6.75848L6.55867 6.47569C6.99578 6.03857 7.58871 5.79297 8.20695 5.79297C8.82519 5.79297 9.41806 6.03857 9.85523 6.47569L10.138 6.75848L9.65524 7.24126H6.75866Z",
    fill: "#C8414B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20721 7.00036C8.34053 7.00036 8.4486 6.89229 8.4486 6.75897C8.4486 6.62565 8.34053 6.51758 8.20721 6.51758C8.07389 6.51758 7.96582 6.62565 7.96582 6.75897C7.96582 6.89229 8.07389 7.00036 8.20721 7.00036Z",
    fill: "#FFD250"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24139 7.00036C7.37471 7.00036 7.48278 6.89229 7.48278 6.75897C7.48278 6.62565 7.37471 6.51758 7.24139 6.51758C7.10807 6.51758 7 6.62565 7 6.75897C7 6.89229 7.10807 7.00036 7.24139 7.00036Z",
    fill: "#FFD250"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17205 7.00036C9.30537 7.00036 9.41345 6.89229 9.41345 6.75897C9.41345 6.62565 9.30537 6.51758 9.17205 6.51758C9.03874 6.51758 8.93066 6.62565 8.93066 6.75897C8.93066 6.89229 9.03874 7.00036 9.17205 7.00036Z",
    fill: "#FFD250"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27572 9.17188H3.86182V9.65466H6.27572V9.17188Z",
    fill: "#C8414B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86182 11.1032L5.31005 10.6205V10.1377L3.86182 10.6205V11.1032Z",
    fill: "#C8414B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanish);
export default __webpack_public_path__ + "static/media/spanish.c18fb271.svg";
export { ForwardRef as ReactComponent };